const loadImg = (src) =>
  new Promise((res) => {
    if (!src) return res(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => res(img);
    img.onerror = () => res(null);
    img.src = src;
  });

const TEXT = {
  onair: ["I'M ON AIR", "NOW", "Tune in on the 24/7 radio"],
  chart: ["I'M IN THE", "WEEKLY CHART", "Give me a Flame this week"],
  award: ["SELECTED BY", "FUORIONDA", "Independent. Curated. On air 24/7."],
  aotm: ["ARTIST OF", "THE MONTH", "Prime time, every night, all month"],
};

export async function makeStoryCard({ kind, name, track, photo, extra, url }) {
  const c = document.createElement("canvas");
  c.width = 1080;
  c.height = 1920;
  const x = c.getContext("2d");
  x.fillStyle = "#07090E";
  x.fillRect(0, 0, 1080, 1920);
  const img = await loadImg(photo);
  if (img) {
    const s = Math.max(1080 / img.width, 1100 / img.height);
    x.globalAlpha = 0.85;
    x.drawImage(img, (1080 - img.width * s) / 2, 260, img.width * s, img.height * s);
    x.globalAlpha = 1;
  }
  const g = x.createLinearGradient(0, 600, 0, 1920);
  g.addColorStop(0, "rgba(7,9,14,0)");
  g.addColorStop(0.45, "rgba(7,9,14,.95)");
  g.addColorStop(1, "#07090E");
  x.fillStyle = g;
  x.fillRect(0, 0, 1080, 1920);
  x.strokeStyle = "rgba(255,255,255,.05)";
  for (let i = 0; i < 1080; i += 54) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i, 1920); x.stroke(); }
  x.fillStyle = "#FF2E63";
  x.beginPath(); x.arc(110, 150, 16, 0, Math.PI * 2); x.fill();
  x.font = "700 34px 'Space Mono', monospace";
  x.fillText("LIVE", 145, 162);
  x.fillStyle = "#F8FAFC";
  x.font = "900 44px Outfit, sans-serif";
  x.fillText("FUORIONDA", 700, 164);
  for (let i = 0; i < 40; i++) {
    const h = 30 + Math.abs(Math.sin(i * 0.7)) * 150;
    x.fillStyle = h > 140 ? "#FF2E63" : "#00F5D4";
    x.fillRect(90 + i * 23, 1180 - h, 14, h);
  }
  const [a, b, sub] = TEXT[kind];
  x.fillStyle = "#00F5D4";
  x.font = "700 40px 'Space Mono', monospace";
  x.fillText(a, 90, 1290);
  x.fillStyle = "#F8FAFC";
  x.font = "900 150px Outfit, sans-serif";
  x.fillText(b, 84, 1440, 910);
  x.fillStyle = "#FF2E63";
  x.font = "800 64px Outfit, sans-serif";
  x.fillText(name.toUpperCase(), 90, 1560, 900);
  x.fillStyle = "#94A3B8";
  x.font = "400 44px Chivo, sans-serif";
  if (track) x.fillText(`"${track}"`, 90, 1630, 900);
  if (extra) { x.fillStyle = "#FFB800"; x.font = "700 44px 'Space Mono', monospace"; x.fillText(extra, 90, 1700, 900); }
  x.fillStyle = "#F8FAFC";
  x.font = "500 38px Chivo, sans-serif";
  x.fillText(sub, 90, 1790);
  x.fillStyle = "#64748B";
  x.font = "400 30px 'Space Mono', monospace";
  x.fillText(url.replace(/^https?:\/\//, ""), 90, 1850, 900);
  return c.toDataURL("image/png");
}

export function download(dataUrl, filename) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  a.click();
}
